<template>
  <b-modal
    ref="bModal"
    size="xs"
    modal-class="modalConfirmation"
    ok-variant="-primary btn-sm"
    cancel-variant="-primary btn__outline btn-sm"
    :title="$t('registry.modal.selectPathologistTitle')"
    centered
    qa="modal-pathologist-assignment"
    @hide="onHide"
  >
    <div class="mb-3">
      {{ $t('registry.modal.selectPathologistContent') }}
    </div>
    <vt-combo-select
      v-model="selectedPathologist"
      qa="modal-pathologist-assignment-selector-div"
      :options="pathologists"
      label="fullName"
      name="pathologistId"
    />
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            qa="modal-pathologist-assignment-cancel-button"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide()"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            qa="modal-pathologist-assignment-accept-button"
            class="btn--primary btn-sm"
            :params="{ promise: selection }"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.accept') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'ModalPathologistAssignment',
    data() {
        return {
            onOk: (selectedPathologist) => {},
            onCancel: () => {},
            pathologists: [],
            selectedPathologist: null
        }
    },
    methods: {
        async showAndSelectOne(pathologists, onOk, onCancel) {
            this.pathologists = pathologists
            this.onOk = onOk || ((selectedPathologist) => {})
            this.onCancel = onCancel || (() => {})
            this.$refs.bModal.show()
        },
        show() {
            this.$refs.bModal.show()
        },
        onHide() {
            this.selection()
            this.onOk = function() {
            }
        },
        hide() {
            this.$refs.bModal.hide()
        },
        selection() {
            this.onOk(this.selectedPathologist)
            this.$refs.bModal.hide()
        }
    }
}

</script>

<style>

.modalConfirmation .modal-dialog{
 width: 30% !important;
}

.modalConfirmation .modal-body{
  padding: 15px !important;
}

</style>
